import { render } from "./ActivePrice.vue?vue&type=template&id=3bd71cc0&ts=true"
import script from "./ActivePrice.vue?vue&type=script&lang=ts"
export * from "./ActivePrice.vue?vue&type=script&lang=ts"

import "./ActivePrice.vue?vue&type=style&index=0&id=3bd71cc0&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__